import { useEffect } from "react";
import Quagga from '@ericblade/quagga2';
import { Button, Icon } from "@chakra-ui/react";
import { FiX } from "react-icons/fi";

import { validIsbn } from "../../../utils/validIsbn";

import { Video } from './styles';

interface ScannerProps {
	onRequestClose: (close: boolean) => void;
	handleCode: (code: string) => void;
	device: string;
}
const ModalScanner: React.FC<ScannerProps> = ({ 
	onRequestClose,
	handleCode,
	device
}) => {
	// let scannerAttemps = 0;

	const onDetected = (result: any) => {
		Quagga.offDetected(onDetected);

		const isbn = result.codeResult.code;
		// console.log('codigo: ', isbn);

		if (validIsbn(isbn)) {
			Quagga.stop();
			handleCode(isbn);
			onRequestClose(false);
		} /* else {
			if (scannerAttemps >= 5) {
				alert('Não foi possível ler o código de barras, por favor, tente novamente.');
			}
		} */

		// scannerAttemps++;
		Quagga.onDetected(onDetected);

		return isbn;
	}

	useEffect(() => {
		if (navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === 'function') {
			Quagga.init({
				inputStream: {
					name: 'Live',
					type: 'LiveStream',
					target: '#video',
					// size: 1920,
					singleChannel: false,
					constraints: {
						// width: window.screen.width,
						// height: window.screen.height,
						facingMode: 'environment',
						deviceId: device,
					},
					/* photoSettings: {
						fillLightMode: "torch", // or "flash"
						focusMode: "continuous",
					}, */
				},
				locator: {
					patchSize: 'medium',
					halfSample: true,
				},
				frequency: 10,
				locate: true,
				decoder: {
					readers: [
						"code_128_reader",
						"ean_reader",
						"ean_8_reader",
						"code_39_reader",
						"code_39_vin_reader",
						"codabar_reader",
						"upc_reader",
						"upc_e_reader",
						"i2of5_reader"
					],
				},
			},
				(err: any) => {
					if (err) {
						console.error(err);
						alert(err);
						return;
					}
					Quagga.start();
				},
			);

			Quagga.onDetected(onDetected);
		}
	}, []);

	return (
		<>
			<Video id="video" />

			<Button
				position="absolute"
				p={0}
				top={[-70, -70, 4]}
				left={3}
				backgroundColor="gray.100"
				borderRadius="full"
				zIndex="999999999"
				_hover={{ background: 'gray.200' }}
				_focus={{ background: 'gray.200' }}
				onClick={async () => {
					await Quagga.stop();
					onRequestClose(false);
				}}
			>
				<Icon as={FiX} fontSize={25} color="blue.500" />
			</Button>
		</>
	)
}

export default ModalScanner;